/* ================================================================ */
// DATA ACTIONS - Datasets | Datasets.js
/* ================================================================ */
/* ========================================== */
// Imports
/* ========================================== */
import 'dotenv/config';
import PropTypes from 'prop-types';
// LoadersGL
import {registerLoaders, _selectLoader, load} from '@loaders.gl/core';
import {Tiles3DLoader} from '@loaders.gl/3d-tiles';
import {CSVLoader} from '@loaders.gl/csv';
import {ZipLoader} from '@loaders.gl/zip';
// Selectors
import {getDatasetsById} from '../../selectors/Data';
// Helpers
import {callAPI, callEditCSV, callUploadMedia, addData, mappify} from '.';
// Constants
import {LoadingTypes, DatasetTypes} from '@myglobe/core/dist/types';
registerLoaders([Tiles3DLoader, CSVLoader, ZipLoader]);
/* ========================================== */
// Actions
/* ========================================== */
// > Datasets Data
export const FETCH_DATASETS = 'FETCH_DATASETS';
export const FETCH_DATASETS_FAILURE = 'FETCH_DATASETS_FAILURE';
export const FETCH_DATASETS_SUCCESS = 'FETCH_DATASETS_SUCCESS';

export const UPDATE_DATASET = 'UDATE_DATASET';
export const UPDATE_DATASET_FAILURE = 'UDATE_DATASET_FAILURE';
export const UPDATE_DATASET_SUCCESS = 'UDATE_DATASET_SUCCESS';

export const UPLOAD_MEDIA = 'UPLOAD_MEDIA';
export const UPLOAD_MEDIA_FAILURE = 'UPLOAD_MEDIA_FAILURE';
export const UPLOAD_MEDIA_SUCCESS = 'UPLOAD_MEDIA_SUCCESS';
/* ========================================== */
// Action Functions
/* ========================================== */
/* ========================================== */
/**
 * Fetch Datasets
 * --------------
 * Retrieves datasets by uuid from the myglobe api
 * 
 * @param {array} datasetIDs dataset uuids to fetch 
 */
export function fetchDatasets(datasetIDs) {
    return (dispatch, getState) => {
        dispatch({type: FETCH_DATASETS});
        var fetchDatasetIDs = datasetIDs;
        // Check loading mode
        if(process.env.DATA_LOAD_MODE === LoadingTypes.SEQUENTIAL) {
            // Check for already loaded layers 
            const currentDatasetIDs = getDatasetsById(getState());
            // Check all layer ids are present in loaded layers
            const loadedDatasetIDs = datasetIDs.filter(id=>currentDatasetIDs.includes(id));
            // Find missing layers and set specific fetch request ids
            fetchDatasetIDs = datasetIDs.filter(id=>(id && !loadedDatasetIDs.includes(id)));
            console.debug('Data > Datasets (Actions) | ', 'fetchDatasets -', 'currentDatasetIDs:', currentDatasetIDs, 'loadedDatasetIDs:', loadedDatasetIDs, 'datasetsToFetch:', fetchDatasetIDs);
        }
        // External Endpoint Fetch
        if(fetchDatasetIDs.length > 0) {
            let query = '{';
            fetchDatasetIDs.forEach((id, i)=>query += `dataset${i}: datasetById(id: "${id}") {
                id
                name
                type
                endpoint
                geoId
                lastUpdated
                config
            }\n`);
            query+='}';
            
            return callAPI(query)
                .then(response=>{
                    const {data} = response;
                    console.debug('Data > Datasets (Actions) | ', 'fetchDatasets -', 'response data:', data);                    
                    // Get all datasets with endpoint data resolved
                    const formattedData = Promise.all(Object.values(data).map(async item => {
                        console.debug('Data > Datasets (Actions) | ', 'fetchDatasets -', 'data item:', item);
                        const endpointData = await fetchEndpointData(item.endpoint);
                        const config = JSON.parse(item.config);
                        return {
                            ...item,
                            endpointData,
                            config
                        };
                    }));
                    // Add datasets to hashmap after all datasets have been retrieved
                    formattedData.then(retrievedData=>{
                        const payload = mappify('name', retrievedData);
                        dispatch(addData('datasets', payload));
                        // TODO: ASYNC SUCCESS HANDLING
                        dispatch({type: FETCH_DATASETS_SUCCESS});
                    });
                })
                .catch(error=>{
                    console.warn('Data > Datasets (Actions) | ', 'fetchDatasets -', error);
                    dispatch({type: FETCH_DATASETS_FAILURE, error });
                });
        }
    };
}
fetchDatasets.propTypes = {
    datasetIds: PropTypes.arrayOf(PropTypes.string).isRequired
};
/* ========================================== */
/**
 * Get Endpoints Data
 * ------------------
 * Retrieves all data for a given 
 * array of dataset endpoints
 * 
 * @param {array} endpoints endpoint urls 
 */
export async function getEndpointsData(endpoints) {
    return Promise.all(endpoints.map(async endpoint=>await fetchEndpointData(endpoint)));
}
getEndpointsData.propTypes = {
    endpoints: PropTypes.arrayOf(PropTypes.string).isRequired
};
/* ========================================== */
/**
 * Fetch Endpoint Data
 * -------------------
 * Handles loader selection according to endpoint filetype
 * and returns the data 
 * 
 * @param {string} endpoint url endpoint to external or internal files
 */
export async function fetchEndpointData(endpoint) {
    // Select appropriate loader according to endpoint file type
    const loader = _selectLoader(null, endpoint);
    const endpointData = await load(endpoint, loader);
    return endpointData;
}
fetchEndpointData.propTypes = {
    endpoint: PropTypes.string.isRequired
};

/* ========================================== */
/**
 * Upload Dataset
 * -------------------
 * Send the endpoint and
 * and the modified data
 * 
 * @param {string} datasetID url endpoint to external or internal files
 * @param {array} dataset the modified dataset
 */
export function updateDataset(endpoint, dataset) {
    // Select appropriate loader according to endpoint file type
    // const loader = _selectLoader(null, endpoint);
    // const endpointData = await load(endpoint, loader);
    // return endpointData;
    console.log("Updating",dataset);
    // convert back to csv

    // const query = 
    // return callAPI(query)
    //     .then(response=>{
    // const dataSuccess = await ();
    return (dispatch, getState) => {
        dispatch({type: UPDATE_DATASET});
        return callEditCSV({dataset,endpoint}).then(response=>{console.log(response);})
            .then(response=>{
                console.log(response);
                dispatch({type: UPDATE_DATASET_SUCCESS});
            });
    }
    //return callEditCSV({dataset,endpoint}).then(response=>{console.log(response);});
}
updateDataset.propTypes = {
    datasetID: PropTypes.string.isRequired,
    dataset: PropTypes.array.isRequired,
};

/* ========================================== */
/**
 * Upload Image
 * -------------------
 * Send the file and get back the
 * path & file data
 * 
 * @param {File} file url endpoint to external or internal files
 */
export function uploadMedia(file) {
    // Select appropriate loader according to endpoint file type
    // const loader = _selectLoader(null, endpoint);
    // const endpointData = await load(endpoint, loader);
    // return endpointData;
    console.log("uploading",file);
    // convert back to csv

    // const query = 
    // return callAPI(query)
    //     .then(response=>{
    // const dataSuccess = await ();
    return (dispatch, getState) => {
        dispatch({type: UPLOAD_MEDIA});
        return callUploadMedia(file)
            .then(response=>{
                console.log('trigger here',response);
                if(response.status!=200) {
                    console.log(response)
                    //temp
                    //dispatch({type: UPLOAD_MEDIA_SUCCESS, payload:'foo.jpg'});
                    dispatch({type: UPLOAD_MEDIA_FAILURE, error:response.error, payload:response.status });
                } else {                    
                    dispatch({type: UPLOAD_MEDIA_SUCCESS, payload:response.data.name});
                }
            })
        .catch(error=>{
                console.warn('Data > Datasets (Actions) | ', 'uploadMedia -', error);
                dispatch({type: UPLOAD_MEDIA_FAILURE, error, payload:500 });
        });;
    }
    //return callEditCSV({dataset,endpoint}).then(response=>{console.log(response);});
}
uploadMedia.propTypes = {
    file: PropTypes.object.isRequired
};